import { DictionaryData, EmmitChange } from "@customHooks/useGenericStore.js";
import {
  BANNER_CURRENT_INDEX,
  CFW_ACTIVATE_SOCIAL_BUTTONS,
  CFW_BANNER_REFRESHER,
  CFW_CURRENT_TRANSLATION,
  CFW_ERROR,
  CFW_HYDRATION_COMPLETE,
  CFW_IS_MOBILE,
  CFW_LOAD_MENU,
  CFW_LOAD_ON_SCROLL,
  CFW_NON_PERSISTENT_STATE,
  CFW_PROMISE_FETCHER_STATE,
  CFW_SCROLL_COUNTER,
  CFW_SCROLL_COUNTER_PROCESSED,
  CFW_SOCIAL_INTEGRATION,
  CFW_UPDATE_DEFAULT_DATA,
  DIALOGHOLDER,
  FILTERHOLDER,
  PROCESS_DELETE,
  PROCESS_UPDATE,
  Response_SelectedTranslation,
  Response_SiteMapUrlData,
  Response_TranslationItem,
  UPDATESITEMAP,
} from "@genericComponents/CFW.js";
import { HasProperty } from "@genericComponents/Common.js";
import { Decrypt } from "@genericComponents/SFW.js";
const GUID = await import("@asyncImports/GUID.js").then((mod) => mod.GUID);
const CommonDebouncer = await import("@asyncImports/CommonDebouncer.js").then(
  (mod) => mod.CommonDebouncer,
);
export const persistConfig = {
  blacklist: [
    CFW_SOCIAL_INTEGRATION,
    CFW_HYDRATION_COMPLETE,
    Response_SiteMapUrlData,
    Response_TranslationItem,
    CFW_ERROR,
    CFW_SCROLL_COUNTER,
    CFW_LOAD_ON_SCROLL,
    CFW_SCROLL_COUNTER_PROCESSED,
    CFW_ACTIVATE_SOCIAL_BUTTONS,
    CFW_LOAD_MENU,
    "@@INIT",
    DIALOGHOLDER,
    FILTERHOLDER,
    Response_SelectedTranslation,
    CFW_IS_MOBILE,
    CFW_BANNER_REFRESHER,
    BANNER_CURRENT_INDEX,
    CFW_UPDATE_DEFAULT_DATA,
    "TOTAL_STATE",
    "TOTAL_CASH",
    "HANDLE_SEO_PROCESS",
    UPDATESITEMAP,
  ],
  blacklistContains: [
    CFW_UPDATE_DEFAULT_DATA,
    CFW_NON_PERSISTENT_STATE,
    Response_TranslationItem,
    CFW_PROMISE_FETCHER_STATE,
    "ApplicationProposalData",
  ],
};
export const globalVariables = {};
export const initDefaultData = new Map();
export const SetDefaultData = (defaultDataStateName, listStateName) => {
  if (GetState(defaultDataStateName) && typeof window !== "undefined") {
    SetState(CFW_UPDATE_DEFAULT_DATA, GUID());
    initDefaultData.set(listStateName, GetState(listStateName));
  }
};
export const RehydrationState = (results) => {
  try {
    if (results) {
      Object.keys(results).forEach((keyName) => {
        if (HasProperty(results, keyName)) {
          if (
            !Array.isArray(results[keyName]) ||
            (Array.isArray(results[keyName]) && results[keyName].length)
          ) {
            SetState(Decrypt(keyName), results[keyName]);
          }
        }
      });
    }
  } catch (error) {
    console.log("Rehydration State Error", error.Message);
  }
};
export const ValildateEntries = (
  stateErrorList,
  stateToStoreErrorMessages,
  exceptForFields = [],
) => {
  const processFailedLabel = GetState(globalVariables[CFW_CURRENT_TRANSLATION])[
    "696"
  ];
  const errorCollection = GetState(stateErrorList, null);
  if (window.children) {
    delete window.children;
  }
  if (errorCollection) {
    const errors = Object.keys(errorCollection)
      .filter(
        (item) => errorCollection[item] && !exceptForFields.includes(item),
      )
      .map((item) => `${errorCollection[item]}`);
    SetState(
      stateToStoreErrorMessages,
      errors?.length
        ? `<div class="note"><h1>${processFailedLabel}:</h1>${errors.join("")}</div>`
        : null,
    );
    return !errors?.length;
  }
  return true;
};
export const ClearEntries = (state, freshState) => {
  SetState(state, { ...freshState });
};
export const UpdateStateField = (pKey, pField, pVal, secondsDelay = null) => {
  const currentData = { ...GetState(pKey) };
  if (
    currentData &&
    JSON.stringify(currentData[pField]) !== JSON.stringify(pVal)
  ) {
    currentData[pField] = pVal;
  }
  SetState(pKey, currentData, secondsDelay);
};

export const GetState = (pKey, defaultValue = null) => {
  return DictionaryData.get(pKey) ?? defaultValue;
};

export const RemoveState = (pKey, secondsDelay = null) => {
  if (!secondsDelay) {
    if (DictionaryData.has(pKey)) {
      DictionaryData.delete(pKey);
      if (typeof window !== "undefined") {
        window.IndexedDBPostMessage(PROCESS_DELETE, {
          key: pKey,
        });
      }
      EmmitChange(pKey);
    }
  } else {
    CommonDebouncer(
      pKey,
      () => {
        if (DictionaryData.has(pKey)) {
          DictionaryData.delete(pKey);
          if (typeof window !== "undefined") {
            window.IndexedDBPostMessage(PROCESS_DELETE, {
              key: pKey,
            });
          }
          EmmitChange(pKey);
        }
      },
      secondsDelay * 1000,
    );
  }
};

export const SetState = (pKey, pVal, secondsDelay = null) => {
  if (JSON.stringify(pVal) !== JSON.stringify(GetState(pKey))) {
    if (!secondsDelay) {
      DictionaryData.set(pKey, pVal);
      if (
        typeof window !== "undefined" &&
        !persistConfig.blacklist.includes(pKey) &&
        !persistConfig.blacklistContains.find((item) => pKey.includes(item))
      ) {
        window.IndexedDBPostMessage(PROCESS_UPDATE, {
          key: pKey,
          value: pVal,
        });
      }
      EmmitChange(pKey);
    } else {
      CommonDebouncer(
        pKey,
        () => {
          DictionaryData.set(pKey, pVal);
          if (typeof window !== "undefined") {
            window.IndexedDBPostMessage(PROCESS_UPDATE, {
              key: pKey,
              value: pVal,
            });
          }
          EmmitChange(pKey);
        },
        secondsDelay * 1000,
      );
    }
  }
};
export const GetStateField = (pKey, pField, defaultValue = null) => {
  const currentData = typeof pKey === "string" ? GetState(pKey) : pKey;
  if (currentData) {
    return currentData[pField] ?? defaultValue;
  }
  return defaultValue;
};
